import { FunctionComponent, useState } from "react";
import UserForm from "./UserForm";
import PageBody from "@components/bodies/PageBody";
import PageLayout from "@components/layouts/PageLayout";
import { RouteComponentProps, useParams } from "react-router-dom";

const UserScreen: FunctionComponent<RouteComponentProps> = () => {
  const { userId } = useParams<{ userId: string }>();

  const [editMode, setEditMode] = useState<boolean>(false);

  return (
    <PageLayout>
      <>
        <PageBody>
          <UserForm
            userId={userId ? userId : ""}
            editMode={editMode}
            setEditMode={setEditMode}
          />
        </PageBody>
      </>
    </PageLayout>
  );
};

export default UserScreen;
